import { NextPageWithLayout } from '@/layouts'
import { PresalesLayout } from '@/layouts/PresalesLayout'
import { getProjectPhase } from '@/services/ProjectsService/ProjectsService'
import { getShopifyCollection, ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { getSweepstake } from '@/services/SweepstakeService'
import { PhaseSlug, SweepstakeObject } from '@/types/codegen-federation'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { PreSalesGiveawayView } from '@/views/PreSales/PreSalesGiveawayView'

interface PreSalesPageProps {
  theatricalSlug: string
  tickets?: ShopifyProductWithBundles[]
  sweepstake: SweepstakeObject
  phase: PhaseSlug | null
  trailerExperimentVal: string | null
}

export const PreSalesPage: NextPageWithLayout<PreSalesPageProps> = ({ tickets, theatricalSlug, phase, sweepstake }) => {
  return (
    <div className="absolute inset-0 !top-0 !overflow-x-hidden bg-white lg:fixed">
      <PreSalesGiveawayView sweepstake={sweepstake} theatricalSlug={theatricalSlug} tickets={tickets} phase={phase} />
    </div>
  )
}

export const getServerSideProps = getServerSidePropsErrorHandler(
  async ({ federationClient, locale, next404, params }) => {
    const theatricalSlug = params?.slug as string

    const sweepstake = await getSweepstake(federationClient, theatricalSlug)

    if (!sweepstake) {
      return next404()
    }

    const collectionId = sweepstake.bundlesCollectionId

    const tickets = collectionId ? await getShopifyCollection({ collectionId }) : null
    const phase = await getProjectPhase(federationClient, theatricalSlug)

    return {
      props: {
        tickets,
        theatricalSlug,
        phase,
        sweepstake,
        ...(await loadTranslations(locale, ['common', 'home', 'tickets', 'chatbot', 'account'])),
      },
    }
  },
)

PreSalesPage.getLayout = (page) => {
  return <PresalesLayout isDarkMode={false}>{page}</PresalesLayout>
}
export default PreSalesPage
